import { z, ZodType } from "zod";

export function zUnchecked<T>() {
  return z.any() as unknown as ZodType<T>;
}
